var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-footer',{staticClass:"elShowWhenWebFlex",attrs:{"app":"","padless":"","absolute":""}},[_c('div',{staticClass:"footer-wrap",class:{ simplifyClass: this.$store.state.isSimplify }},[_c('div',[_vm._v(" ©"+_vm._s(2022)+" - "+_vm._s(new Date().getFullYear())+" By "+_vm._s(_vm.blogInfo.webSite.author)+" ")])])])
}
var staticRenderFns = []

export { render, staticRenderFns }